import { Grid } from "@material-ui/core";
import { TextField } from "@ofqual/portal-components/components/TextField";
import React from "react";
import { ScopeApplication } from "../../domain/ScopeApplication";
import { SectionProps } from "./SectionProps";
import { Controller } from "react-hook-form";
import { Error } from "../common/Error";

export const QuestionThree: React.FC<SectionProps<ScopeApplication>> = ({
  control,
  errors,
  disabled,
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="questionThree"
          as={
            <TextField
              variant="outlined"
              label="Question 3 answer"
              data-test="question-3"
              fullWidth
              multiline
              rows="15"
              readOnly={disabled}
            />
          }
        />
        {errors.questionThree && errors.questionThree.message && (
          <Error>{errors.questionThree.message}</Error>
        )}
      </Grid>
    </Grid>
  );
};
